import { Link } from "react-router-dom";
import VerificationBadge from "./VerificationBadge";
import LastVerifiedDate from "./LastVerifiedDate";
import OfficialLinkButton from "./OfficialLinkButton";

export default function CompanyCard({ company, headingLevel = 2 }) {
  const Heading = headingLevel === 3 ? "h3" : "h2";
  return (
    <article className="soft-card soft-card-hover flex h-full flex-col p-5 sm:p-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-blue-700">{company.country}</p>
          <Heading className="mt-2 text-2xl font-black tracking-tight text-neutral-950">{company.name}</Heading>
        </div>
        <VerificationBadge />
      </div>
      <p className="mt-4 text-sm leading-7 text-neutral-600">{company.description}</p>
      <div className="mt-4 flex flex-wrap gap-2">
        {company.categories.slice(0, 3).map((category) => <span key={category} className="data-badge">{category}</span>)}
      </div>
      <dl className="mt-5 grid gap-2 text-sm text-neutral-700">
        {company.role && <div><dt className="font-black text-neutral-950">Role</dt><dd>{company.role}</dd></div>}
        <div><dt className="font-black text-neutral-950">Location</dt><dd>{[company.city, company.country].filter(Boolean).join(", ")}</dd></div>
        <div><dt className="font-black text-neutral-950">Products</dt><dd>{company.products.join(", ")}</dd></div>
      </dl>
      <div className="mt-auto pt-6">
        <LastVerifiedDate date={company.lastVerified} />
        <div className="mt-4 flex flex-wrap gap-2">
          <Link className="btn-primary" to={`/robotics-companies/${company.slug}`}>View company profile</Link>
          <OfficialLinkButton href={company.website} ariaLabel={`Visit the official ${company.name} website`}>Official website</OfficialLinkButton>
        </div>
      </div>
    </article>
  );
}
